<template>
  <div class="">
    <m-content-wrapper :content-type="contentType" :content-category="contentCategory">
      <template v-slot="{contents}">
        <StoriesMenu @selectedStory="selectedStory" :stories="contents"/>
        <StoriesMainWrapper v-if="isStoryActive" :stories="contents" :storyIndex="storyIndex" @close="selectedStory"/>
      </template>
    </m-content-wrapper>
  </div>
</template>

<script>
import mContentWrapper from "./../../../Wrappers/ContentWrapper";
import StoriesMenu from './Menu/StoriesMenu.vue'
import StoriesMainWrapper from './Main/StoriesMainWrapper.vue'
import {ContentArchiveProps} from "../../Archive/ContentArchiveProps";

export default {
  components: {mContentWrapper, StoriesMenu, StoriesMainWrapper},
  props: {
    ...ContentArchiveProps,
  },
  data() {
    return {
      isStoryActive: false,
      storyIndex: null
    }
  },
  methods: {
    selectedStory(data) {
      this.isStoryActive = data.isStoriesActive
      this.storyIndex = data.index
    }
  }
}
</script>

<style scoped>

</style>